export default "__VITE_ASSET__DeVjnb66__"